<template>
  <el-drawer
    class="sideDrawer"
    destroy-on-close
    :size="drawerSize"
    title="添加套餐"
    :visible="dialogVisible"
    :before-close="beforeClose"
    append-to-body
  ><i
      class="iconfont icon-back-quanping iconFull"
      @click="drawerSize = '100%'"
      v-if="drawerSize == '70%'"
    />
    <i
      @click="drawerSize = '70%'"
      class="iconfont icon-back-tuichuquanping iconFull"
      v-else
    />
    <el-form
      ref="form"
      :model="tempValue"
      label-width="100px"
      :rules="rules"
      style="padding: 20px"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="套餐名称:"
            prop="combo_name"
          >
            <eco-input
              v-model="tempValue.combo_name"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="收费类型:"
            prop="charge_type"
          >
            <el-select
              style="width: 100%"
              v-model="tempValue.charge_type"
              @change="chargeTypeChange"
            >
              <el-option
                v-for="item in boDefIdList"
                :key="item.id"
                :value="item.key"
                :label="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="年:"
            prop="year"
            v-if="rules.year"
          >
            <el-input-number
              v-model="tempValue.year"
              :precision="1"
              style="width: 100%"
              :step="0.1"
              step-strictly
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="用户数:"
            prop="user_num"
            v-if="rules.user_num"
          >
            <el-input-number
              v-model="tempValue.user_num"
              style="width: 100%"
              :step="1"
              step-strictly
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="次数:"
            prop="times"
            v-if="rules.times"
          >
            <el-input-number
              v-model="tempValue.times"
              style="width: 100%"
              :step="1"
              step-strictly
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="套餐价格:"
            prop="price"
          >
            <el-input-number
              v-model="tempValue.price"
              :min="0"
              :precision="2"
              style="width: 100%"
              :step="0.1"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="关联产品:"
            prop="relation"
          >
            <el-select
              v-model="tempValue.relation"
              style="width: 100%"
            >
              <el-option
                v-for="item in purposeList"
                :key="item.account_module"
                :value="item.account_module"
                :label="item.account_name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="编制人:"
            prop="create_user"
          >
            <eco-input
              style="width: 100%"
              disabled
              v-model="tempValue.create_user"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="编制时间:"
            prop="create_time"
          >
            <eco-input
              disabled
              style="width: 100%"
              v-model="tempValue.create_time"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="demo-drawer__footer">
      <el-button
        @click="beforeClose"
        size="small"
      >取消</el-button> <el-button
        @click="submit('form')"
        type="primary"
        :loading="tempAddLoading"
        size="small"
      >确定</el-button>

    </div>
  </el-drawer>
</template>

<script>
import form from '@/api/form'
import * as constants from './constants'
import utils from '@/utils'
import { mapState } from 'vuex'
export default {
  name: 'tempAdd',
  props: {
    selectModel: String,
    dialogVisible: {
      type: Boolean,
      default: () => false
    }
  },
  watch: {
    dialogVisible(newVal) {
      if (newVal) this.getSflxTree()
    }
  },
  data() {
    return {
      drawerSize: '70%',
      tempValue: {
        combo_name: '',
        charge_type: '',
        year: '',
        user_num: '',
        times: '',
        price: '',
        form_contract_template_detail: [],
        relation: null
      },
      boDefIdList: [],
      formKeyList: [],
      purposeList: [],
      fileList: [],
      tempAddLoading: false,
      pageBean: {
        page: 1,
        pageSize: 999,
        total: 0
      },
      rules: {
        combo_name: [{ required: true, message: '请输入套餐名称', trigger: 'blur' }],
        charge_type: [{ required: true, message: '请选择收费类型', trigger: 'blur' }],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }]
        // relation: [
        //   { required: true, message: "请选择关联产品", trigger: "change" }
        // ]
      },
      selectUploadId: '',
      ...constants
    }
  },
  computed: {
    ...mapState({
      currentUserDetail: (state) => state.user.currentUserDetail
    })
  },
  mounted() {
    // 默认创建时间 创建人
    this.getSflxTree()
  },
  methods: {
    chargeTypeChange(e) {
      let rules = {
        combo_name: [{ required: true, message: '请输入套餐名称', trigger: 'blur' }],
        charge_type: [{ required: true, message: '请选择收费类型', trigger: 'blur' }],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }]
      }
      let temp = this.boDefIdList.find((item) => item.key === e)
      if (temp.children) {
        temp.children.forEach((items) => {
          if (items.name === '用户数') {
            rules['user_num'] = [{ required: true, message: '请输入用户数', trigger: 'blur' }]
          }
          if (items.name === '年数') {
            rules['year'] = [{ required: true, message: '请输入年', trigger: 'blur' }]
          }
          if (items.name === '次数') {
            rules['times'] = [{ required: true, message: '请输入次数', trigger: 'blur' }]
          }
        })
        this.rules = rules
      }
      // if (e)
      let params = {
        chargeType: e
      }
      form.getRelateProductByChargeType(params).then((res) => {
        this.tempValue.relation = null
        this.purposeList = res
      })
    },
    // 获取收费类型树结构
    getSflxTree() {
      let params = {
        typeKey: 'sflx'
      }
      form.getByTypeKeyForComBo(params).then((resp) => {
        this.boDefIdList = resp
        this.tempValue.create_user_id = this.currentUserDetail.user.userId
        this.tempValue.create_user = this.currentUserDetail.user.fullname
        this.tempValue.create_time = utils.formatDate(new Date())
      })
    },
    beforeClose() {
      this.$emit('beforeClose')
      this.tempValue = {
        combo_name: '',
        charge_type: '',
        year: '',
        user_num: '',
        times: '',
        price: '',
        form_contract_template_detail: [],
        relation: null
      }
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        this.tempAddLoading = true
        if (valid) {
          let params = Object.assign({}, this.tempValue)
          params['sub_third_combo_account_relation'] = []
          if (this.tempValue.relation) {
            this.purposeList.forEach((item) => {
              if (item.account_module === this.tempValue.relation) {
                params['sub_third_combo_account_relation'].push(item)
              }
            })
          }
          form
            .getAddThirdCombo(params)
            .then(() => {
              this.tempAddLoading = false
              this.beforeClose()
            })
            .catch(() => {
              this.tempAddLoading = false
            })
        } else {
          this.tempAddLoading = false
          return false
        }
      })
    },
    clearFile() {
      this.tempValue.file = ''
      this.tempValue.form_contract_template_detail = []
    },
    emitFile(value) {
      let params = {
        fileId: value.file.response.fileId
      }
      form.getDetailListByFileId(params).then((resp) => {
        this.tempValue.file = JSON.stringify(value.fileList)
        this.tempValue.form_contract_template_detail = resp
        this.$refs['form'].clearValidate('file')
      })
    },
    /**
     *
     * @param aa value
     * @param bb 赋值name
     * @param list 查找的list
     * @param listKey code转换
     */
    selName(aa, bb, list, listKey = 'code') {
      let temp = list.find((item) => item[listKey] === aa)
      this.tempValue[bb] = temp ? temp[bb] : ''
    }
  }
}
</script>

<style scoped>
/deep/.el-form-item {
  width: 100%;
}
/deep/.el-form-item__content {
  width: calc(100% - 100px);
}
</style>
